/**
 * Geographic coordinate with string values to preserve decimal precision
 */
export interface ICoordinate {
    lat: string;
    lng: string;
}
